import { render } from "./ProjectBanner.vue?vue&type=template&id=236eb0b1"
import script from "./ProjectBanner.vue?vue&type=script&lang=js"
export * from "./ProjectBanner.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__